module.exports = __webpack_public_path__ + "img/ms-logo-dark.5b246a9e.svg";